import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useOnboardingPlannerViewContext } from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/ViewContext';
import ViewFormLayoutPicker
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/ViewFormLayoutPicker';
import { Divider } from '@material-ui/core';
import OnboardingPlannerViewSurveyModal
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Modals/OnboardingPlannerViewSurveyModal';

const styles = (theme) => ({
  root: {
    background: theme.palette.facet.lightGray,
  },
});

const ViewContent = ({
  className,
  classes,
}) => {
  const { onboardingPlannerViewResource, surveyIsOpen, closeSurvey } = useOnboardingPlannerViewContext();

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {onboardingPlannerViewResource.attr('onboardingSections').resources().list().map(sectionResource => {
        return (
          <div key={sectionResource.attr('stepName')}>
            <ViewFormLayoutPicker sectionResource={sectionResource} />
            <Divider />
          </div>
        );
      })}
      {surveyIsOpen && (
        <OnboardingPlannerViewSurveyModal
          onClose={closeSurvey}
        />
      )}
    </Box>
  );
};

ViewContent.defaultProps = {
  className: '',
};

ViewContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ViewContent);
